import {Fragment} from "preact";
import s from "./radioInput.module.css";
import {useAppContext} from "../../../../../../contexts";

const RadioInput = (props) => {
    // Destructured props
    const {
        formValues,
        handleChange,
        item
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Checks if the current input is checked
    const isChecked = formValues.overallRating === item;

    return (
        <Fragment>
            <fieldset key={item}>
                <input
                    type="radio"
                    name={"rating"}
                    id={`rating-input-${item}`}
                    className={"hidden"}
                    value={item}
                    checked={isChecked}
                    onInput={(e) => handleChange({
                        target: "RATING",
                        event: e
                    })}
                />
                <label
                    htmlFor={`rating-input-${item}`}
                    className={
                        `${s.label} ${
                            (
                                !formValues.overallRating && !isChecked
                            ) ? (
                                highContrast ? s.dmIsEnabled : s.isEnabled
                            ) : (
                                formValues.overallRating === item
                            ) ? (
                                highContrast ? s.dmIsSelected : s.isSelected
                            ) : s.isDisabled
                        }`
                    }
                >
                    {item}
                </label>
            </fieldset>
        </Fragment>
    )
}

export default RadioInput;
